import { Tgt_Attr_Lnk } from '../models/domain/tgt_attr_lnk';
import { TargetWrapper } from 'src/app/modules/design/transforms/target/target.wrapper';
import { CommonEnums } from '../common.enums';
import { Attribute } from '../models/domain/attribute';
import { DatabaseEnum } from '../databases/databases.enum';

export class Tgt_Attr_LnksUtil {
    private static instance: Tgt_Attr_LnksUtil;

    static getInstance(): Tgt_Attr_LnksUtil {
        if (!Tgt_Attr_LnksUtil.instance) {
            Tgt_Attr_LnksUtil.instance = new Tgt_Attr_LnksUtil();
        }
        return Tgt_Attr_LnksUtil.instance;
    }

    scdDefStartKey: number = 19000101;
    scdDefEndKey: number = 20991231;

    LOADTYPE_SCD_ID: string = "SCD";
    LOADTYPE_INSERT_ID: string = "INS";
    LOADTYPE_UPDATE_ID: string = "UPD";
    LOADTYPE_UPSERT_ID: string = "UPI";
    LOADTYPE_DELETE_ID: string = "DEL";

    TGT_SCD_DATE: string = 'DATE';
    TGT_SCD_KEY: string = 'KEY';

    PRIMARY_KEY: number = 1;

    /**
     * Tgt_Attr_LnksUtil is a singleton class, so use Tgt_Attr_LnksUtil.getInstance() method instead of creating new Tgt_Attr_LnksUtil().
     */
    private constructor() {

    }

    resetUpdKeyFlag(targetWrapper: TargetWrapper): void {
        for (let j: number = 0; j < targetWrapper.target.tgt_Attr_Lnks.length; j++) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = targetWrapper.target.tgt_Attr_Lnks[j];

            tgt_Attr_Lnk.updKeyFlag = CommonEnums.flag.NO;
            tgt_Attr_Lnk.valid_Cd = "0";
        }
    }

    setUpdKeyFlagForPrimaryKeys(targetWrapper: TargetWrapper): void {
        let primaryKeyAttr_Ids: Array<number> = new Array<number>();

        for (let i: number = 0; i < targetWrapper.target.dataObject.attributes.length; i++) {
            let attribute: Attribute = targetWrapper.target.dataObject.attributes[i];

            if (attribute.attrKeyTyp_Id == this.PRIMARY_KEY) {
                primaryKeyAttr_Ids.push(attribute.attr_Id);
            }
        }

        for (let j: number = 0; j < targetWrapper.target.tgt_Attr_Lnks.length; j++) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = targetWrapper.target.tgt_Attr_Lnks[j];

            if (primaryKeyAttr_Ids.indexOf(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) != -1) {
                tgt_Attr_Lnk.updKeyFlag = CommonEnums.flag.YES;

                if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1)
                    tgt_Attr_Lnk.valid_Cd = "TGT_UNQ_COL_NO_LNK";
                else
                    tgt_Attr_Lnk.valid_Cd = "0";
            }
        }
    }

    setUpdKeyFlagForDistKeyFlags(targetWrapper: TargetWrapper): void {
        ///    if (targetWrapper.databaseWrapper.isPartition) return;

        let distKeyFlagAttr_Ids: Array<number> = new Array<number>();

        for (let i: number = 0; i < targetWrapper.target.dataObject.attributes.length; i++) {
            let attribute: Attribute = targetWrapper.target.dataObject.attributes[i];

            if (attribute.distKeyFlag != 0) {
                distKeyFlagAttr_Ids.push(attribute.attr_Id);
            }
        }

        for (let j: number = 0; j < targetWrapper.target.tgt_Attr_Lnks.length; j++) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = targetWrapper.target.tgt_Attr_Lnks[j];

            if (distKeyFlagAttr_Ids.indexOf(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) != -1) {
                tgt_Attr_Lnk.updKeyFlag = CommonEnums.flag.YES;

                if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1)
                    tgt_Attr_Lnk.valid_Cd = "TGT_UNQ_COL_NO_LNK";
                else
                    tgt_Attr_Lnk.valid_Cd = "0";
            }
        }
    }

    setReadonlyTgtAttrLnk(targetWrapper: TargetWrapper): void {
        for (let i: number = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = targetWrapper.target.tgt_Attr_Lnks[i];

            tgt_Attr_Lnk.tgtAttrNm = "";
            tgt_Attr_Lnk.srcAttrNm = "";
            tgt_Attr_Lnk.srcDTypNm = "";
            tgt_Attr_Lnk.tgtDTypNm = "";

            let tgtAttribute: Attribute = targetWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id);
            if (tgtAttribute) {
                tgt_Attr_Lnk.tgtAttrNm = tgtAttribute.attrNm;

                ///   let tgtDTypNm: string = DIDatabases.getAttributeType( targetWrapper.dbTyp_Id, tgtAttribute );
                ///   tgt_Attr_Lnk.tgtDTypNm = tgtDTypNm;  
            }

            let carrFwdAttr: any = targetWrapper.carryForwardAttributesHMapIds.get(tgt_Attr_Lnk.lnk_Obj_Id + '-' + tgt_Attr_Lnk.lnk_Obj_Attr_Id);
            if (carrFwdAttr) {
                tgt_Attr_Lnk.srcAttrNm = carrFwdAttr.name;
                tgt_Attr_Lnk.srcDTypNm = carrFwdAttr.attrDTypNm;
            }
        }
    }


    setUpdKeyFlag(targetWrapper: TargetWrapper, loadType: string) {

        if (loadType == this.LOADTYPE_UPDATE_ID || loadType == this.LOADTYPE_DELETE_ID) {
            for (let i: number = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
                if (targetWrapper.sub_Ids.get(targetWrapper.target.tgt_Attr_Lnks[i].tgt_dObj_Inst_Attr_Id).attrNm == "Id") {
                    targetWrapper.target.tgt_Attr_Lnks[i].updKeyFlag = 'Y'

                    if (targetWrapper.target.tgt_Attr_Lnks[i].lnk_Obj_Attr_Id == -1)
                        targetWrapper.target.tgt_Attr_Lnks[i].valid_Cd = "TGT_UNQ_COL_NO_LNK";
                    else
                        targetWrapper.target.tgt_Attr_Lnks[i].valid_Cd = "0";

                }
                else {
                    targetWrapper.target.tgt_Attr_Lnks[i].updKeyFlag = 'N'
                }

            }
        }

    }




    unLinkSalesForceTgt_Attr_Lnks(selectedTgt_Attr_Lnks: Array<Tgt_Attr_Lnk>, targetWrapper: TargetWrapper) {
        if (targetWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE) {
            for (let i: number = 0; i < selectedTgt_Attr_Lnks.length; i++) {
                if (targetWrapper.sub_Ids.get(selectedTgt_Attr_Lnks[i].tgt_dObj_Inst_Attr_Id).attrNm != "Id") {
                    selectedTgt_Attr_Lnks[i].lnk_Obj_Id = -1;
                    selectedTgt_Attr_Lnks[i].lnk_Obj_Attr_Id = -1;

                    selectedTgt_Attr_Lnks[i].valid_Cd = "0";
                    selectedTgt_Attr_Lnks[i].srcAttrNm = "";
                    selectedTgt_Attr_Lnks[i].srcDTypNm = "";

                    if (selectedTgt_Attr_Lnks[i].hashKey == 'Y') {
                        selectedTgt_Attr_Lnks[i].hashKey = 'N';
                        targetWrapper.isHashKeySelected = false;
                    }
                    targetWrapper.validateTgt_Attr_Lnk(selectedTgt_Attr_Lnks[i]);
                }
            }
        }
    }


    // updKeyFlagChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     if (targetWrapper.target.tgt_Inst.tgtLoadType == CommonEnums.tgtLoadType.SCD) {
    //         tgt_Attr_Lnk.scdFlag = 'N';
    //         tgt_Attr_Lnk.currIndFlag = 'N'
    //         tgt_Attr_Lnk.scdStartDtFlag = 'N'
    //         tgt_Attr_Lnk.scdEndDtFlag = 'N'
    //         tgt_Attr_Lnk.surrogate_Key = 'N'
    //     }

    //     tgt_Attr_Lnk.update_Column = 'N';

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // insert_ColumnChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     if (targetWrapper.target.tgt_Inst.tgtLoadType == CommonEnums.tgtLoadType.UPSERT) {
    //         tgt_Attr_Lnk.scdFlag = 'N';
    //         tgt_Attr_Lnk.currIndFlag = 'N'
    //         tgt_Attr_Lnk.scdStartDtFlag = 'N'
    //         tgt_Attr_Lnk.scdEndDtFlag = 'N'
    //         tgt_Attr_Lnk.surrogate_Key = 'N'
    //     }

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // update_ColumnChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     if (targetWrapper.target.tgt_Inst.tgtLoadType == CommonEnums.tgtLoadType.UPSERT) {
    //         tgt_Attr_Lnk.scdFlag = 'N';
    //         tgt_Attr_Lnk.currIndFlag = 'N'
    //         tgt_Attr_Lnk.scdStartDtFlag = 'N'
    //         tgt_Attr_Lnk.scdEndDtFlag = 'N'
    //         tgt_Attr_Lnk.surrogate_Key = 'N'
    //         tgt_Attr_Lnk.updKeyFlag = 'N';
    //     }

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // scdFlagChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     tgt_Attr_Lnk.updKeyFlag = 'N';
    //     tgt_Attr_Lnk.scdStartDtFlag = 'N';
    //     tgt_Attr_Lnk.scdEndDtFlag = 'N';
    //     tgt_Attr_Lnk.currIndFlag = 'N'
    //     tgt_Attr_Lnk.surrogate_Key = 'N'

    //     if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
    //         tgt_Attr_Lnk.scdFlag = "N";
    //     }

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // isHashKeyFlagDisabled(targetWrapper: TargetWrapper, tgt_Attr_Lnk: Tgt_Attr_Lnk): boolean {

    //     for (let j = 0; j < targetWrapper.target.tgt_Attr_Lnks.length; j++) {
    //         let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[j];

    //         if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

    //         if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
    //             tgt_Attr_Lnk.hashKey = "N";
    //             return true;
    //         }

    //         return false;
    //     }
    // }

    // hashKeyChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {

    //     if (tgt_Attr_Lnk.hashKey == 'Y') {
    //         if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1 ||
    //             tgt_Attr_Lnk.lnk_Obj_Id == -1) {
    //             tgt_Attr_Lnk.hashKey = 'N';
    //             targetWrapper.isHashKeySelected = false;
    //             return;
    //         }
    //         for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
    //             let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];

    //             tgt_Attr_LnkTmp.updKeyFlag = 'N';
    //             tgt_Attr_LnkTmp.scdFlag = 'N';

    //             if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) {
    //                 tgt_Attr_LnkTmp.hashKey = 'N';
    //             }
    //         }
    //         targetWrapper.target.tgt_Inst.scdDefStartDt = "";

    //         targetWrapper.isHashKeySelected = true;
    //     } else {
    //         targetWrapper.isHashKeySelected = false;
    //     }

    //     targetWrapper.doValidate();
    // }

    // scdStartDtFlagChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
    //         tgt_Attr_Lnk.updKeyFlag = 'N';
    //         tgt_Attr_Lnk.scdFlag = 'N';
    //         tgt_Attr_Lnk.scdEndDtFlag = 'N';
    //         tgt_Attr_Lnk.currIndFlag = 'N';
    //         tgt_Attr_Lnk.surrogate_Key = 'N';
    //     }

    //     for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
    //         let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
    //         if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

    //         if (tgt_Attr_LnkTmp.scdStartDtFlag != 'N') {
    //             tgt_Attr_LnkTmp.scdStartDtFlag = 'N';
    //             targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
    //         }
    //     }

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // scdEndDtFlagChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
    //         tgt_Attr_Lnk.updKeyFlag = 'N';
    //         tgt_Attr_Lnk.scdFlag = 'N';
    //         tgt_Attr_Lnk.scdStartDtFlag = 'N';
    //         tgt_Attr_Lnk.currIndFlag = 'N';
    //         tgt_Attr_Lnk.surrogate_Key = 'N';
    //     }


    //     for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
    //         let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
    //         if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

    //         if (tgt_Attr_LnkTmp.scdEndDtFlag != 'N') {
    //             tgt_Attr_LnkTmp.scdEndDtFlag = 'N';
    //             targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
    //         }
    //     }

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // currIndFlagChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
    //         tgt_Attr_Lnk.updKeyFlag = 'N';
    //         tgt_Attr_Lnk.surrogate_Key = 'N';
    //         tgt_Attr_Lnk.scdFlag = 'N';
    //         tgt_Attr_Lnk.scdStartDtFlag = 'N';
    //         tgt_Attr_Lnk.scdEndDtFlag = 'N';

    //         tgt_Attr_Lnk.lnk_Obj_Id = -1;
    //         tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
    //     }


    //     for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
    //         let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
    //         if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

    //         if (tgt_Attr_LnkTmp.currIndFlag != 'N') {
    //             tgt_Attr_LnkTmp.currIndFlag = 'N';
    //             targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
    //         }
    //     }

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // surrogate_KeyChanged(tgt_Attr_Lnk: Tgt_Attr_Lnk, targetWrapper: TargetWrapper): void {
    //     if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
    //         tgt_Attr_Lnk.scdFlag = 'N';
    //         tgt_Attr_Lnk.currIndFlag = 'N'
    //         tgt_Attr_Lnk.updKeyFlag = 'N';
    //         tgt_Attr_Lnk.scdStartDtFlag = 'N'
    //         tgt_Attr_Lnk.scdEndDtFlag = 'N'

    //         tgt_Attr_Lnk.lnk_Obj_Id = -1;
    //         tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
    //     }


    //     for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
    //         let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
    //         if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

    //         if (tgt_Attr_LnkTmp.surrogate_Key != 'N') {
    //             tgt_Attr_LnkTmp.surrogate_Key = 'N';
    //             targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
    //         }
    //     }

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     targetWrapper.doValidate();
    // }

    // validateTgtAttrLnk(dataItem: any, targetWrapper: TargetWrapper): void {
    //     let attrNmObjectsHMap = [];
    //     for (let i = 0; i < targetWrapper.carryForwardAttributes.length; i++) {
    //         let transformObject = targetWrapper.carryForwardAttributes[i];

    //         for (let j = 0; j < transformObject.items.length; j++) {
    //             let attributeObject: AttributeCarryForward = transformObject.items[j];
    //             let attrNm = attributeObject.text.toLowerCase();

    //             //if( attrNmObjectsHMap[attrNm] != null ) continue;

    //             attrNmObjectsHMap[attrNm] = attributeObject;
    //         }
    //     }

    //     let dObjAttrNmsHMap = [];
    //     for (let j = 0; j < targetWrapper.dataObjectWrapper.dataObject.attributes.length; j++) {
    //         dObjAttrNmsHMap[targetWrapper.dataObjectWrapper.dataObject.attributes[j].attr_Id] = targetWrapper.dataObjectWrapper.dataObject.attributes[j].attrNm;
    //     }
    //     //let attrNm = angular.lowercase(dObjAttrNmsHMap[dataItem.tgt_dObj_Inst_Attr_Id]);
    //     let attrNm = targetWrapper.sub_IdsHMap[dataItem.tgt_dObj_Inst_Attr_Id];
    //     let _attrObject = attrNmObjectsHMap[attrNm];

    //     if (_attrObject)
    //         dataItem.valid_Cd = verifyFamily(dataItem, _attrObject, targetWrapper) ? "0" : "-1";

    //     targetWrapper.validateTgt_Attr_Lnk(dataItem);

    //     targetWrapper.doValidate();
    // }

    // autoMapping(targetWrapper: TargetWrapper): void {
    //     let attrNmObjectsHMap = [];
    //     for (let i = 0; i < targetWrapper.carryForwardAttributes.length; i++) {
    //         let transformObject = targetWrapper.carryForwardAttributes[i];

    //         for (let j = 0; j < transformObject.items.length; j++) {
    //             let attributeObject = transformObject.items[j];

    //             let attrNm = angular.lowercase(attributeObject.text);

    //             /*if( targetWrapper.dbTyp_Id != 6 ) // Removed Hive target 06-09-2018 //DDS-6181
    //         let attrNm = angular.lowercase(attributeObject.text);
    //         else 
    //                 let attrNm = attributeObject.text;*/
    //             //if( attrNmObjectsHMap[attrNm] != null ) continue;

    //             if (targetWrapper.databaseWrapper.excludedAttrNms.indexOf(angular.uppercase(attrNm)) != -1) continue;

    //             attrNmObjectsHMap[attrNm] = attributeObject;
    //         }
    //     }

    //     /*PERFORMANCE	 * 
    //      * let dObjAttrNmsHMap = [];
    //     for( let j = 0; j < targetWrapper.dataObjectWrapper.attributes.length; j++ ) {
    //         dObjAttrNmsHMap[targetWrapper.dataObjectWrapper.attributes[j].attr_Id] = targetWrapper.dataObjectWrapper.attributes[j].attrNm;
    //     }*/

    //     for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
    //         let tgt_Attr_Lnk = targetWrapper.target.tgt_Attr_Lnks[i];

    //         tgt_Attr_Lnk.lnk_Obj_Id = -1;
    //         tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;

    //         let subObject = targetWrapper.sub_IdsHMap[tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id];
    //         if (subObject) {
    //             let attrNm = angular.lowercase(subObject.attrNm);
    //         }

    //         /*if( targetWrapper.dbTyp_Id != 6 ) { // Removed Hive target 06-09-2018 //DDS-6181
    //         let subObject = targetWrapper.sub_IdsHMap[tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id];
    //         if( subObject ) {
    //             let attrNm = angular.lowercase(subObject.attrNm);
    //         }
    //     } else {
    //         let subObject = targetWrapper.sub_IdsHMap[tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id];
    //         if( subObject ) {
    //             let attrNm = subObject.attrNm; //dObjAttrNmsHMap[tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id];
    //         }
    //     }*/

    //         if (attrNm) {
    //             let sameAttrNmObject = attrNmObjectsHMap[attrNm];
    //             if (!sameAttrNmObject) continue;

    //             //				if( !sameAttrNmObject.showUnderline ) continue;

    //             tgt_Attr_Lnk.lnk_Obj_Id = sameAttrNmObject.obj_Id;
    //             tgt_Attr_Lnk.lnk_Obj_Attr_Id = sameAttrNmObject.attr_Id;
    //         }

    //         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);

    //         let _attrObject = attrNmObjectsHMap[attrNm];

    //         tgt_Attr_Lnk.valid_Cd = verifyFamily(tgt_Attr_Lnk, _attrObject, targetWrapper) ? "0" : "-1";

    //         //DITgt_Attr_LnksUtil.setReadonlyTgtAttrLnk(targetWrapper, tgt_Attr_Lnk, targetWrapper.dobjHMap);
    //     }

    //     targetWrapper.doValidate();
    // }

    // setWarningForTgt_Attr_Lnks(targetWrapper: TargetWrapper): void {
    //     for (let i = 0; i < targetWrapper.tgt_Attr_Lnks.length; i++) {
    //         let tgt_Attr_Lnk = targetWrapper.tgt_Attr_Lnks[i];

    //         let carryForwardAttribute = targetWrapper.carryForwardAttributeObjectsHMapIds[tgt_Attr_Lnk.lnk_Obj_Id + '-' + tgt_Attr_Lnk.lnk_Obj_Attr_Id];
    //         if (!carryForwardAttribute) continue;

    //         tgt_Attr_Lnk.valid_Cd = verifyFamily(tgt_Attr_Lnk, carryForwardAttribute, targetWrapper) ? "0" : "-1";
    //     }
    // }

    // unLinkTgt_Attr_Lnks(selectedTgt_Attr_Lnks: Array<Tgt_Attr_Lnk>, targetWrapper: TargetWrapper): void {
    //     if (selectedTgt_Attr_Lnks.length == 0) return;

    //     for (let i = 0; i < selectedTgt_Attr_Lnks.length; i++) {
    //         let tgt_Attr_Lnk: Tgt_Attr_Lnk = selectedTgt_Attr_Lnks[i];

    //         tgt_Attr_Lnk.lnk_Obj_Id = -1;
    //         tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;

    //         tgt_Attr_Lnk.valid_Cd = "0";
    //         tgt_Attr_Lnk.srcAttrNm = "";
    //         tgt_Attr_Lnk.srcDTypNm = "";

    //         if (tgt_Attr_Lnk.hashKey == 'Y') {
    //             tgt_Attr_Lnk.hashKey = 'N';
    //             targetWrapper.isHashKeySelected = false;
    //         }
    //         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
    //     }

    //     targetWrapper.doValidate();
    // }

    // getAttrNm(attr_Id: number, targetWrapper: TargetWrapper): string {
    //     for (let i: number = 0; i < targetWrapper.target.dataObject.attributes.length; i++) {
    //         if (targetWrapper.target.dataObject.attributes[i].attr_Id == attr_Id) {
    //             return targetWrapper.target.dataObject.attributes[i].attrNm;
    //         }
    //     }

    //     return '';
    // }

    // getAttributeType(attr_Id: number, targetWrapper: TargetWrapper): string {

    //     /*for( let i = 0; i < targetWrapper.target.dataObject.attributes.length; i++ ) {
    //         if( targetWrapper.target.dataObject.attributes[i].attr_Id == attr_Id )
    //             return DIDatabases.getAttributeType( targetWrapper.dbTyp_Id, targetWrapper.target.dataObject.attributes[i] );
    //     }*/
    //     let attribute = targetWrapper.sub_IdsHMap[attr_Id];
    //     if (attribute)
    //         return DIDatabases.getAttributeType(targetWrapper.dbTyp_Id, attribute)

    //     return '';
    // }

    // getAttributeDbType_Id(attr_Id: number, targetWrapper: TargetWrapper): string {
    //     /*for( let i = 0; i < targetWrapper.target.dataObject.attributes.length; i++ ) {
    //         if( targetWrapper.target.dataObject.attributes[i].attr_Id == attr_Id )
    //             return targetWrapper.target.dataObject.attributes[i].attrDTyp_Id;
    //     }*/

    //     let attribute = targetWrapper.sub_IdsHMap[attr_Id];
    //     if (attribute)
    //         return attribute.attrDTyp_Id;

    //     return '';
    // }

    // verifyFamily(tgt_Attr_Lnk: Tgt_Attr_Lnk, carryforwardAttribute: CarryForwardAttribute, targetWrapper: TargetWrapper): boolean {
    //     let attribute = targetWrapper.sub_IdsHMap[tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id];//DIAttributesUtil.get( tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, targetWrapper.dataObjectWrapper.attributes );
    //     if (!attribute) return;

    //     let dbTyp_Id1 = targetWrapper.dataObjectWrapper.dbTyp_Id;
    //     let attrDTyp_Id1 = attribute.attrDTyp_Id;

    //     //			let dbTyp_Id2 = targetWrapper.nativeDbTyp_Id;
    //     //			let attrDTyp_Id2 = carryforwardAttribute.attrDTyp_Id; 
    //     //			
    //     //			let allowString = true;
    //     //			let intTolet = false;
    //     //			
    //     //			let isSameFamily = DIDatabases.isSameFamily( dbTyp_Id1, attrDTyp_Id1, dbTyp_Id2, attrDTyp_Id2, allowString, intTolet );
    //     //			
    //     //			if( !isSameFamily )
    //     //				return isSameFamily;

    //     let dataTypeName1 = '';
    //     let dataType1 = DIDatabases.getDatatype(dbTyp_Id1, attrDTyp_Id1);
    //     if (dataType1) dataTypeName1 = angular.lowercase(dataType1.name);

    //     let dataTypeName2 = carryforwardAttribute.attrDTyp_Name;
    //     //			let dataType2 = DIDatabases.getDatatype(dbTyp_Id2, attrDTyp_Id2);
    //     //			if( dataType2 ) dataTypeName2 = angular.lowercase(dataType2.name);

    //     if (dataTypeName1 == dataTypeName2)
    //         return true;

    //     return false;
    // }

    // changeSourceAttribute(tgt_Attr_Lnk: Tgt_Attr_Lnk, carryforwardAttribute: CarryForwardAttribute, targetWrapper: TargetWrapper): void {
    //     tgt_Attr_Lnk.lnk_Obj_Id = carryforwardAttribute.obj_Id;
    //     tgt_Attr_Lnk.lnk_Obj_Attr_Id = carryforwardAttribute.attr_Id;

    //     tgt_Attr_Lnk.valid_Cd = this.verifyFamily(tgt_Attr_Lnk, carryforwardAttribute, targetWrapper) ? "0" : "-1";

    //     targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);

    //     tgt_Attr_Lnk.currIndFlag = 'N'
    //     tgt_Attr_Lnk.surrogate_Key = 'N';



    //     //DITgt_Attr_LnksUtil.setReadonlyTgtAttrLnk(targetWrapper, tgt_Attr_Lnk, targetWrapper.dobjHMap);

    //     targetWrapper.doValidate();
    // }

    // isScdDtDisabled(objectWrapper, tgt_Attr_Lnk, fromStart) {
    //     console.log('factory:: DITgt_Attr_Lnks:: isScdDtDisabled()::');

    //     let dbTyp_Id = getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper)

    //     if (objectWrapper.target.tgt_Inst.scdType == "DATE") {
    //         if (!DIDatabases.isDateFamily(objectWrapper.dbTyp_Id, dbTyp_Id)) {
    //             return true;
    //         }
    //         else
    //             return false;

    //         //				}else if(tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1 && fromStart) {
    //         //					tgt_Attr_Lnk.scdStartDtFlag = "N";
    //         //
    //         //					return true;
    //         //				} 
    //     } else if (objectWrapper.target.tgt_Inst.scdType == "DATE") {
    //         return false;
    //     }
    //     else if (objectWrapper.target.tgt_Inst.scdType == "KEY") {
    //         if (!DIDatabases.isNumberFamily(objectWrapper.dbTyp_Id, dbTyp_Id))
    //             return true;
    //         else
    //             return false;
    //     }

    //     return false;
    // }

    // isUniKeyDisabled(objectWrapper, tgt_Attr_Lnk1) {
    //     console.log('factory:: DITgt_Attr_Lnks:: isUniKeyDisabled()::');

    //     let distKeyFlagAttr_Ids = [];

    //     if (!objectWrapper.databaseWrapper.isPartition) return false;

    //     if (tgt_Attr_Lnk1.lnk_Obj_Attr_Id == -1) {
    //         tgt_Attr_Lnk1.updKeyFlag = "N";
    //     }

    //     for (let i = 0; i < objectWrapper.dataObjectWrapper.attributes.length; i++) {
    //         let attribute = objectWrapper.dataObjectWrapper.attributes[i];

    //         if (attribute.distKeyFlag != 0)
    //             distKeyFlagAttr_Ids.push(attribute.attr_Id);
    //     }

    //     for (let j = 0; j < objectWrapper.tgt_Attr_Lnks.length; j++) {
    //         let tgt_Attr_Lnk = objectWrapper.tgt_Attr_Lnks[j];

    //         if (tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk1.tgt_dObj_Inst_Attr_Id) continue;

    //         if (distKeyFlagAttr_Ids.indexOf(tgt_Attr_Lnk1.tgt_dObj_Inst_Attr_Id) != -1)
    //             return true;
    //         else if (tgt_Attr_Lnk1.lnk_Obj_Attr_Id == -1 || objectWrapper.isHashKeySelected) {
    //             tgt_Attr_Lnk1.updKeyFlag = "N";

    //             return true;
    //         }

    //         break;
    //     }

    //     return false;
    // }

    // isScdFlagDisabled(objectWrapper, tgt_Attr_Lnk) {
    //     for (let j = 0; j < objectWrapper.tgt_Attr_Lnks.length; j++) {
    //         let tgt_Attr_LnkTmp = objectWrapper.tgt_Attr_Lnks[j];

    //         if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

    //         if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1 || objectWrapper.isHashKeySelected) {
    //             tgt_Attr_Lnk.scdFlag = "N";

    //             return true;
    //         }

    //         return false;
    //     }
    // }

    // getAttributesLengthList(attributes: Array<Attribute>) {
    //     let list = [];

    //     for (let i = 0; i <= attributes.length; i++) {
    //         list.push({ "value": i });
    //     }

    //     return list;
    // }

    // isCurrIndDisabled(objectWrapper, tgt_Attr_Lnk) {
    //     console.log('factory:: DITgt_Attr_Lnks:: isCurrIndDisabled()::');

    //     let attrDTyp_Id = getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper)

    //     if (objectWrapper.dbTyp_Id == 6) {
    //         if (DIDatabases.isStringFamily(objectWrapper.dbTyp_Id, attrDTyp_Id)) {
    //             return false;
    //         }
    //     } else if (DIDatabases.isNumberFamily(objectWrapper.dbTyp_Id, attrDTyp_Id)) {
    //         return false;
    //     }

    //     return true;
    // }

    // isSurrKeyDisabled(objectWrapper: ObjectWrapper, tgt_Attr_Lnk: Tgt_Attr_Lnk): boolean {
    //     let dbTyp_Id = this.getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper)

    //     if (DIDatabases.isNumberFamily(objectWrapper.dbTyp_Id, dbTyp_Id)) {
    //         return false;
    //     }
    //     else
    //         return true;

    //     return false;
    // }

    copy(tgt_Attr_Lnks: Array<Tgt_Attr_Lnk>): Array<Tgt_Attr_Lnk> {
        let tgt_Attr_LnksTmp: Array<Tgt_Attr_Lnk> = new Array<Tgt_Attr_Lnk>();

        for (let i: number = 0; i < tgt_Attr_Lnks.length; i++) {
            tgt_Attr_LnksTmp.push(Tgt_Attr_Lnk.parse(tgt_Attr_Lnks[i]));
        }

        return tgt_Attr_LnksTmp;
    }

    copyFrom(tgt_Attr_Lnks: Array<Tgt_Attr_Lnk>, tgt_Attr_LnksTmp: Array<Tgt_Attr_Lnk>): void {
        let tgt_Attr_LnksMap: Map<number, Tgt_Attr_Lnk> = new Map();

        for (let i: number = 0; i < tgt_Attr_Lnks.length; i++) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = tgt_Attr_Lnks[i] as Tgt_Attr_Lnk;
            tgt_Attr_LnksMap.set(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, tgt_Attr_Lnk);
        }
        tgt_Attr_Lnks.splice(0, tgt_Attr_Lnks.length);

        for (let i: number = 0; i < tgt_Attr_LnksTmp.length; i++) {
            let tgt_Attr_LnkTmp: Tgt_Attr_Lnk = tgt_Attr_LnksTmp[i] as Tgt_Attr_Lnk;

            let tgt_Attr_Lnk: Tgt_Attr_Lnk = tgt_Attr_LnksMap.get(tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id);
            if (tgt_Attr_Lnk) {
                tgt_Attr_Lnk.copyFrom(tgt_Attr_LnkTmp);
            } else {
                tgt_Attr_Lnk = Tgt_Attr_Lnk.parse(tgt_Attr_LnkTmp);
            }

            tgt_Attr_Lnks.push(tgt_Attr_Lnk);
        }
    }

    compare(tgt_Attr_Lnks: Array<Tgt_Attr_Lnk>, tgt_Attr_LnksTmp: Array<Tgt_Attr_Lnk>): string {
        let tgt_Attr_LnksLength = tgt_Attr_Lnks.length;
        let tgt_Attr_LnksTmpLength = tgt_Attr_LnksTmp.length;

        if (tgt_Attr_LnksLength != tgt_Attr_LnksTmpLength) {
            return 'tgt_Attr_Lnks length is different.';
        }

        for (let i: number = 0; i < tgt_Attr_LnksLength; i++) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = tgt_Attr_Lnks[i] as Tgt_Attr_Lnk;
            let tgt_Attr_LnkTmp: Tgt_Attr_Lnk = tgt_Attr_LnksTmp[i] as Tgt_Attr_Lnk;
            if (tgt_Attr_Lnk.compare(tgt_Attr_LnkTmp) != '') {
                return "tgt_Attr_Lnks[" + i + "] is not equal.";
            }
        }

        return '';
    }

    toString(tgt_Attr_Lnks: Array<Tgt_Attr_Lnk>): string {
        let str: string = 'Tgt_Attr_Lnk length: ' + tgt_Attr_Lnks.length + ' ';

        for (let i: number = 0; i < tgt_Attr_Lnks.length; i++) {
            str += tgt_Attr_Lnks[i].toString();
        }

        return str;
    }
}